<template>
  <span v-if="iconContent" v-html="iconContent" class="svg-icon" :style="{ '--icon-fill': fill }"></span>
</template>

<script>
import { ref, watch, onMounted } from 'vue';

export default {
  name: 'SvgIcon',
  props: {
    name: { type: String, required: true },
    width: { type: String, default: '1.5rem' },
    height: { type: String, default: '1.5rem' },
    fill: { type: String, default: '#000' },
  },
  setup(props) {
    const iconContent = ref(null);

    const loadIcon = async () => {
      try {
        const iconPath = `/icons/${props.name}.svg`;
        const response = await fetch(iconPath);

        if (response.ok) {
          let svg = await response.text();

          // Set size and remove any fill attributes
          svg = svg.replace(/<svg/, `<svg width="${props.width}" height="${props.height}"`);
          svg = svg.replace(/fill="[^"]*"/g, '');

          iconContent.value = svg;
        } else {
          console.error(`SVG icon not found: ${iconPath}`);
        }
      } catch (error) {
        console.error('Error loading SVG icon:', error);
      }
    };

    onMounted(loadIcon);
    watch(() => props.name, loadIcon);

    return { iconContent };
  }
};
</script>

<style scoped>
.svg-icon {
  display: flex;
  align-items: center;
  justify-content: center;
}

:deep(svg), :deep(path) {
  fill: var(--icon-fill);
  transition: fill 0.3s;
}
</style>
